import { useTranslation } from "react-i18next";
import { Lock, Sparkles, X, Check } from "lucide-react";

const TIER_INFO = {
  starter: {
    label: "Starter",
    price: "19€/mois",
    color: "#1A4D2E",
    perks: [
      "Voir jusqu'à 5 profils candidats",
      "Réservation des candidats",
      "Matching IA partiel",
    ],
  },
  pro: {
    label: "Pro",
    price: "49€/mois",
    color: "#1A4D2E",
    perks: [
      "Voir TOUS les profils candidats",
      "Scores de compatibilité complets",
      "Matching IA complet avec recommandations",
      "Réservation illimitée",
    ],
  },
  premium: {
    label: "Premium",
    price: "99€/mois",
    color: "#C97A20",
    perks: [
      "Tout le plan Pro",
      "Boost de visibilité de vos besoins",
      "Accès prioritaire aux top candidats",
    ],
  },
};

export default function UpgradeModal({ requiredTier = "starter", onClose, onUpgrade }) {
  const { t } = useTranslation();
  const info = TIER_INFO[requiredTier] || TIER_INFO.starter;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="upgrade-modal-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-3xl max-w-md w-full p-8 relative shadow-2xl"
        data-testid="upgrade-modal"
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-[#F0F2EF] text-[#6B726A]"
          data-testid="upgrade-modal-close"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="w-14 h-14 rounded-2xl bg-[#E8F0EA] grid place-items-center mb-5">
          <Lock className="w-6 h-6 text-[#1A4D2E]" />
        </div>

        <h2 className="text-2xl font-medium tracking-tight mb-2" style={{ fontFamily: "Outfit" }}>
          {t("billing.locked_title", { defaultValue: "Profil verrouillé" })}
        </h2>
        <p className="text-sm text-[#6B726A] mb-6">
          {t("billing.locked_desc", {
            defaultValue: "Ce profil candidat est réservé aux pharmacies abonnées. Passez au plan supérieur pour le débloquer.",
          })}
        </p>

        <div className="border border-[#E2E5E0] rounded-2xl p-5 mb-6 bg-gradient-to-br from-[#F7F8F6] to-white">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-[#1A4D2E]" />
              <span className="text-xs uppercase tracking-wide text-[#6B726A] font-medium">
                Plan {info.label}
              </span>
            </div>
            <div className="text-lg font-medium" style={{ fontFamily: "Outfit", color: info.color }}>
              {info.price}
            </div>
          </div>
          <ul className="space-y-2">
            {info.perks.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-[#1f2421]">
                <Check className="w-4 h-4 text-[#1A4D2E] mt-0.5 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 border border-[#E2E5E0] rounded-full py-3 text-sm font-medium text-[#1f2421] hover:bg-[#F7F8F6]"
            data-testid="upgrade-modal-cancel"
          >
            {t("common.cancel")}
          </button>
          <button
            onClick={onUpgrade}
            className="flex-1 rounded-full py-3 text-sm font-medium text-white hover:opacity-90"
            style={{ backgroundColor: info.color }}
            data-testid="upgrade-modal-confirm"
          >
            {t("billing.upgrade_now", { defaultValue: "Voir les plans" })}
          </button>
        </div>
      </div>
    </div>
  );
}
